export default () => ({
    host: process.env.API_BASE_URL || "https://api.post-post-scriptum.com/",
    siteHost: process.env.API_SITE_URL || "https://post-post-scriptum.com/",
    currentCountry: null,
    currentLanguge: null,
    showContactPhone: true,
    langs: null,
    countries: null,
    messages: {},
    minimumOrderPrice: 0,
    minimumOrderPriceCoefficient: process.env.MINIMUM_ORDER_PRICE_COEFFICIENT_IN_RUBLES || 2000,
    instaSlides: [],
    statusPpsCourier: false,
    statusPpsCourierPreorderPayment: false,
    mainMenu: null,
    banner: null,
    productBlocks: null,
    bannerPlacement: {
        EVERYWERE: 0,
        MAIN: 1,
        CATEGORY: 2,
        WOMAN_CATEGORY: 3,
        MAN_CATEGORY: 4,
        WOMAN_CATALOG: 5,
        MAN_CATALOG: 6,
    },
    userHasOrders: false
});
